import { ValidationErrors } from '@angular/forms';

// Define el tipo para los mensajes estáticos (cadenas de texto simples)
type StaticErrorMessages = string;

// Define el tipo para los mensajes dinámicos que son funciones
type DynamicErrorMessages = (error: ValidationErrors) => string;

// Interfaz para los mensajes de error a varios niveles de profundidad
export interface IMessageError {
  [controlName: string]:
    | ErrorMessages
    | StaticErrorMessages
    | DynamicErrorMessages;
}

// Tipo que puede ser un mensaje estático, dinámico o un grupo de errores anidados
type ErrorMessages = {
  [errorKey: string]:
    | StaticErrorMessages
    | DynamicErrorMessages
    | ErrorMessages;
};

export function isErrorMessages(obj: unknown): obj is ErrorMessages {
  return (
    obj != null &&
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    Object.keys(obj).every((key) => typeof key === 'string')
  );
}
